import { appRoutes } from './app';
import { authRoutes } from './auth';
import { clientRoutes } from './client';
import { obligationRoutes } from './obligation';
import { obligorRoutes } from './obligor';
import { openRoutes } from './open';
import { portalRoutes } from './portal';
import { productRoutes } from './product';

export const routes = {
    app: appRoutes,
    auth: authRoutes,
    client: clientRoutes,
    obligation: obligationRoutes,
    obligor: obligorRoutes,
    open: openRoutes,
    portal: portalRoutes,
    product: productRoutes
};
